import { MouseEventHandler, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { NavItem, NavLink } from "reactstrap";
import { NavLinkTrackActive } from "../shared/NavLinkTrackActive";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface SubscriptionTeamNavigationProps {
    id: string,
    onNavigate?: (link: string) => void,
    editLink?: string,
}

/**
 * Navigation under editing of a Subscription Team.
 */
export const SubscriptionTeamNavigation = (props: SubscriptionTeamNavigationProps) => {
    const { id, onNavigate, editLink } = props;
    const { t } = useTranslation();

    // If we have an onNavigate event, we should call that instead of leting the links handle themselves.
    const onNavLinkClick = useCallback<MouseEventHandler>((e) => {
        if (onNavigate) {
            e.preventDefault();
            const link = e.currentTarget.getAttribute("href") ?? '';
            onNavigate(link);
        }
    }, [onNavigate]);

    return (
        <>
            <NavItem>
                <NavLink tag={NavLinkTrackActive} to={editLink ?? `/manage/teams/edit/${id}`} onClick={onNavLinkClick}>
                    <FontAwesomeIcon icon="users" className="nav-icon" />
                    {t('subscriptionTeamNavigation.team', ' Team')}
                </NavLink>
            </NavItem>
            <NavItem>
                <NavLink tag={NavLinkTrackActive} to={`/manage/teams/details/${id}/drivers`} onClick={onNavLinkClick}>
                    <FontAwesomeIcon icon="bus" className="nav-icon" />
                    {t('subscriptionTeamNavigation.drivers', ' Driver members')}
                </NavLink>
            </NavItem>
            <NavItem>
                <NavLink tag={NavLinkTrackActive} to={`/manage/teams/details/${id}/managers`} onClick={onNavLinkClick}>
                    <FontAwesomeIcon icon="user" className="nav-icon" />
                    {t('subscriptionTeamNavigation.managers', ' Manager members')}
                </NavLink>
            </NavItem>
            <NavItem>
                <NavLink tag={NavLinkTrackActive} to={`/manage/teams/details/${id}/assessments`} onClick={onNavLinkClick}>
                    <FontAwesomeIcon icon="clipboard-check" className="nav-icon" />
                    {t('subscriptionTeamNavigation.assessments', ' Required assessments')}
                </NavLink>
            </NavItem>
            <NavItem>
                <NavLink tag={NavLinkTrackActive} to={`/manage/teams/details/${id}/training`} onClick={onNavLinkClick}>
                    <FontAwesomeIcon icon="graduation-cap" className="nav-icon" />
                    {t('subscriptionTeamNavigation.training', ' Required training')}
                </NavLink>
            </NavItem>
        </>
    );
};
